import {UseMutationOptions, useMutation, useQueryClient} from '@tanstack/react-query'
import {httpDeleteNewEmailRequest} from '@features/settings/http/settings.http.ts'
import {User} from '@features/user/types.ts'
import {errorHandler} from '@utilities/helpers.ts'
import {QUERY_KEYS} from '@/queryClient.ts'

export const useDeleteNewEmailRequest = (
    options?: Omit<UseMutationOptions<unknown, unknown, unknown>, 'mutationFn' | 'mutationKey'>
) => {
    const queryClient = useQueryClient()

    return useMutation({
        mutationFn: () =>
            httpDeleteNewEmailRequest({
                params: {
                    response_type: 'extended'
                }
            }),
        onError: errorHandler,
        onSuccess: async (data, variables, context) => {
            await queryClient.cancelQueries({queryKey: [QUERY_KEYS.ME]})
            queryClient.setQueryData(
                [QUERY_KEYS.ME],
                (previousData: User): User => ({
                    ...previousData,
                    newEmail: null
                })
            )
            options?.onSuccess?.(data, variables, context)
        }
    })
}
